module.exports = __webpack_public_path__ + "img/inactive.cbfbdf38.svg";